/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: eslUsersActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the ESL Users module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteEslUser } from './api';

/**
 * Shared helpers for ESL Users module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an ESL User in the form.
 * Pattern: /settings/pbx/esl-users/new?duplicate={id}
 */
export const getEslUserDuplicateUrl = (id: string | number): string =>
  `/settings/pbx/esl-users/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given ESL User id.
 */
export const navigateToEslUserDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getEslUserDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an ESL User by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteEslUser from './api' directly
 */
export const deleteEslUserById = async (
  id: string | number,
  _tenantSlug?: string,
  _userId?: string | number | null
): Promise<void> => {
  await deleteEslUser(id);
};

